import * as i0 from '@angular/core';
import { Inject, Injectable } from '@angular/core';
import * as i1 from '@citi-gcg-173875/citi-utils';
import { WINDOW, NAVIGATOR } from '@citi-gcg-173875/citi-utils';
import { Cookie } from 'ng2-cookies/ng2-cookies';

/** Site Catalyst Service
 *         1. Accepts page level params
 *              - PageName
 *              - LocalPageName
 *              - SiteSection1
 *              - SiteSection2
 *              - SiteSection3
 *              - SiteSection4
 *              - eventList
 *         2. Adds additional user properties
 *              - Channel
 *              - Domain
 *              - PageCat
 *              - PageDef
 *              - Responsive
 *              - Country
 *              - CustomerStatus
 *              - Login Status
 *              - Platform
 *              - Page Language
 *              - CCSID
 *              - Cards Cookie <Optional Param>
 *              - Citi Products
 *              - Cust Prod String
 *              - Cust Prof String
 *              - CUUID <Optional Param>
 *              - Cyota Id
 *              - Last Login Date
 *              - LOB
 *              - ProspectId
 *              - User Type
 *          3. Calls the trigger function to pass the data to Site Catalyst.
 */
class SiteCatalystService {
    static { this.SITECAT_SESSION_STORAGE_KEY = 'sessionPostBrandingStorage'; }
    static { this.CHANNEL = 'us'; }
    static { this.DOMAIN = ''; }
    static { this.PAGECAT = 'cbol transaction'; }
    static { this.PAGEDEF = 'angular page'; }
    static { this.RESPONSIVE = 'yes'; }
    constructor(_window, _navigator, _sessionService) {
        this._window = _window;
        this._navigator = _navigator;
        this._sessionService = _sessionService;
        /** staticuserProp object represents the static user properties
         */
        this.staticUserProp = {
            channel: SiteCatalystService.CHANNEL,
            domain: SiteCatalystService.DOMAIN, //TODO:  does this have the potential to impact?  non-ssr code was setting to window.location.hostname
            pageCat: SiteCatalystService.PAGECAT,
            pageDef: SiteCatalystService.PAGEDEF,
            responsive: SiteCatalystService.RESPONSIVE,
            country: '',
            custStatus: '',
            custLink: '',
            loginStatus: '',
            platform: '',
            pageLanguage: '',
            ccsid: ''
        };
        /** sessionStorageUserProp represents the user properties loaded from session storage.
         */
        this.sessionStorageUserProp = {
            // Optional Param
            cardsCookie: '',
            citiProducts: '',
            custProdString: '',
            custProfString: '',
            // Optional Param
            cuuid: '',
            custType: '',
            cyotaID: '',
            dateActivated: '',
            lastLogindate: '',
            lob: '',
            // Optional Param
            prospectid: '',
            userType: ''
        };
        this.siteCatEventValueMap = {
            click: 'customLinkClick',
            load: 'naAnalyticsPageView',
            cobrowse: 'customLinkClick',
            download: 'customDownload',
            start: 'selfServiceStart',
            complete: 'selfServiceComplete',
            alertCancel: 'alertCancel',
            upload: 'uploadDocument',
            rate: 'ratingsAndReviewsClick'
        };
        if (!!this._window) {
            const hostName = this._window.location.hostname;
            SiteCatalystService.DOMAIN = hostName;
            this.staticUserProp.domain = hostName;
        }
        this.populateStaticUserProp();
        this.getSiteCatDataFromSessionStorage();
    }
    /**
     *  This is a public method exposed to set page level data to be passed to site catalyst.
     *
     */
    setSCPageData(eventType, pageData, medallia) {
        if (!this._window)
            return;
        this.setSCUserData();
        if (typeof this._window.s === 'undefined') {
            this._window.citiData.defaultPageView = true;
        }
        if (eventType === 'cobrowse') {
            this._window.citiData.analyticsEvent = 'cobrowseEvent';
        }
        Object.assign(this._window.citiData, pageData);
        if (this.siteCatEventValueMap[eventType]) {
            this.callSC(this.siteCatEventValueMap[eventType]);
        }
        else {
            this.callSC(eventType);
        }
        if (medallia === true) {
            if (window.KAMPYLE_ONSITE_SDK) {
                window.KAMPYLE_ONSITE_SDK.updatePageView();
            }
        }
    }
    setSCUserData() {
        Object.assign(this._window.citiData, this.sessionStorageUserProp);
        Object.assign(this._window.citiData, this.staticUserProp);
    }
    callSC(eventType) {
        if (this._window && this._window['Bootstrapper']) {
            const bootStrapperEvent = this._window['Bootstrapper'].ensEvent;
            if (typeof bootStrapperEvent === 'object' &&
                typeof this._window['s'] === 'object') {
                setTimeout(() => {
                    console.log("HPTT:: naAnalyticsPageview timeout1 is triggered");
                    bootStrapperEvent.trigger(eventType);
                }, 500);
            }
            else {
                let intervalId = setInterval(() => {
                    if (typeof bootStrapperEvent === 'object' &&
                        typeof this._window['s'] === 'object') {
                        setTimeout(() => {
                            console.log("HPTT:: naAnalyticsPageview timeout2 is triggered");
                            bootStrapperEvent.trigger(eventType);
                        }, 500);
                        clearInterval(intervalId);
                    }
                }, 100);
            }
        }
    }
    getLoggedInStatus() {
        return this._sessionService.isVisitor() ? 'not logged in' : 'logged in';
    }
    getPlatform() {
        return this._navigator &&
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this._navigator.userAgent)
            ? 'Mobile'
            : 'Desktop';
    }
    getPageLanguage() {
        return this.getLocaleCookie() === 'en_US' ? 'english' : 'spanish';
    }
    getLocaleCookie() {
        let locale = Cookie.get('locale');
        return locale !== null ? locale : 'en_US';
    }
    getCountry() {
        let locale = this.getLocaleCookie();
        return locale.split('_')[1].toLowerCase();
    }
    getCCSId() {
        let ccsId = Cookie.get('CCSID');
        if (ccsId && ccsId != "undefined" && ccsId != "null") {
            return ccsId;
        }
        else if (this._window) {
            if (typeof (this._window.sessionStorage) != "undefined" && this._window.sessionStorage.getItem("sessionPostBrandingStorage")) {
                let sessionPostBrandingStorageObject = this._window.sessionStorage.getItem(SiteCatalystService.SITECAT_SESSION_STORAGE_KEY);
                if (sessionPostBrandingStorageObject) {
                    sessionPostBrandingStorageObject = JSON.parse(sessionPostBrandingStorageObject);
                    let siteCatalystBean = sessionPostBrandingStorageObject['siteCatalystBean'];
                    ccsId = siteCatalystBean['ccsid'];
                    return ccsId;
                }
            }
        }
    }
    getCustStatus() {
        return this._sessionService.isVisitor() ? 'prospect' : 'customer';
    }
    populateStaticUserProp() {
        this.staticUserProp.domain = this._window
            ? this._window.location.hostname
            : '';
        (this.staticUserProp.country = this.getCountry()),
            (this.staticUserProp.custStatus = this.getCustStatus()),
            (this.staticUserProp.loginStatus = this.getLoggedInStatus()),
            (this.staticUserProp.platform = this.getPlatform()),
            (this.staticUserProp.pageLanguage = this.getPageLanguage()),
            (this.staticUserProp.ccsid = this.getCCSId());
    }
    getSiteCatDataFromSessionStorage() {
        let sessionParams = this._window
            ? this._window.sessionStorage.getItem(SiteCatalystService.SITECAT_SESSION_STORAGE_KEY)
            : null;
        if (sessionParams) {
            try {
                sessionParams = JSON.parse(sessionParams);
                let siteCatUserProp = sessionParams['siteCatalystBean'];
                // tslint:disable-next-line:forin
                for (let prop in this.sessionStorageUserProp) {
                    this.sessionStorageUserProp[prop] = siteCatUserProp[prop]
                        ? siteCatUserProp[prop]
                        : '';
                }
                if (sessionParams['isCitigold'] == 'Y') {
                    this.sessionStorageUserProp.custType = 'Citigold';
                }
                else if (sessionParams['isCitipriority'] == 'Y') {
                    this.sessionStorageUserProp.custType = 'Citipriority';
                }
                else {
                    this.sessionStorageUserProp.custType = 'Citiblue';
                }
            }
            catch (e) {
                console.log('error occured while parsing sitecat user prop');
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SiteCatalystService, deps: [{ token: WINDOW }, { token: NAVIGATOR }, { token: i1.SessionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SiteCatalystService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: SiteCatalystService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }, { type: i1.SessionService }] });

/*
 * Public API Surface of citi-analytics
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SiteCatalystService };
